<template>
  <Row type="flex" align="middle" class="spec-row">
        <Col flex="1" class="spec-content">
        <span class="spec-item">{{ getTranslation('k258') }}:<Input type="text" style="width:150px" size="small"
            class="spec-input" :value="selectLibrary.SpotModel" disabled /></span>
        <span class="spec-item">{{ getTranslation('k259') }}:<Input type="text" size="small" style="width:150px"
            class="spec-input" :value="selectLibrary.SpotId" disabled /></span>
        <span class="spec-item">{{ getTranslation('b006') }}:<Input type="text" size="small" style="width:50px"
            class="spec-input" :value="selectLibrary.NoWeldProgram" disabled /></span>
        <span class="spec-item">{{ getTranslation('b007') }}:<Input type="text" size="small" style="width:80px"
            class="spec-input" disabled :value="selectLibrary.WeldProgram" /></span>
        <span class="spec-item">{{ getTranslation('k243') }}:<Input type="text" size="small" style="width:80px"
            class="spec-input" :value="selectLibrary.SpotPss" disabled /></span>
        <span class="spec-item">{{ getTranslation('k244') }}:<Input type="text" size="small" style="width:80px"
            class="spec-input" :value="selectLibrary.SpotThk" disabled /></span>
        <span class="spec-item">{{ getTranslation('k241') }}:<Input type="text" size="small" style="width:150px"
            class="spec-input" :value="selectLibrary.SpotName" disabled /></span>
        <span class="spec-item">{{ getTranslation('k222') }}:<Input type="text" size="small" style="width:160px"
            class="spec-input" :value="selectLibrary.created_string" disabled /></span>
        </Col>
      </Row>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'RunningTop', // 组件名称
  components: {
     
  },
  props: {
    selectLibrary: Object,
    
  },
  data() {
    return {

    }
  },
  computed: {
    ...mapGetters(['getTranslation']),   
  },
  watch: {   
  },

  created() {    
    
  },
  methods: {
    
  },

}
</script>

<style scoped>

.spec-row {
  margin-bottom: 16px;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e9ecef;
}

.spec-content {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 12px;
  /* 垂直间距 8px，水平间距 12px */
  align-items: center;
}

.spec-item {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}

.spec-input {
  margin: 0 4px;
}
</style>